/*
 *  helper.serv.js
 */

class HelperServ {

    constructor($sce) {
        this.$sce = $sce;
    }

    sanitizeObj(obj) {
        let copy = angular.copy(obj);
        Object.keys(copy).forEach((key, index) => {
            if (typeof copy[key] === 'string') {
                copy[key] = this.$sce.trustAsHtml(copy[key]);
            }
        });
        return copy;
    }

    getLiteralBounds(bounds) {
        if (angular.isObject(bounds)) {
            let southWest = bounds.getSouthWest();
            let northEast = bounds.getNorthEast();
            return {
                southWestLat: southWest.lat(),
                southWestLng: southWest.lng(),
                northEastLat: northEast.lat(),
                northEastLng: northEast.lng()
            };
        } else {
            return null;
        }
    }

    cancelTimeouts(timeouts, $timeout) {
        timeouts.map((timeout) => {
            $timeout.cancel(timeout);
        });
    }

    checkForGeolocationSupport() {
        return (navigator && navigator instanceof Object && navigator.geolocation) ? true : false;
    }
}

HelperServ.$inject = ['$sce'];

export default HelperServ;